import React from "react"
import { IEnkAuthContextType } from "./auth-provider"

const AuthContext = React.createContext<IEnkAuthContextType | null>(null)

export default AuthContext
